window.onload = function () {
    // 主视频
    TCPlayer("videoPlayerA", {
        fileID: "5285890795642095639",
        appID: "1259605108",
        autoplay: false
    });
    // 小圆点
    TCPlayer("videoPlayerB", {
        fileID: "5285890795642095639",
        appID: "1259605108",
        autoplay: false
    });
    TCPlayer("videoPlayerC", {
        fileID: "5285890795642095639",
        appID: "1259605108",
        autoplay: false
    });

    $(".yuandian").addClass('ani');
    this.document.querySelector('.yuandian').addEventListener("animationend", function () {
        $(".yuandian").removeClass('ani');
        setTimeout(function () {
            $(".yuandian").addClass('ani');
        }, 200)
    });

    // 视频点击切换
    $(".check-list").click(function(){
        $(".video-list").eq($(this).index()).show().siblings().hide();
        $(this).addClass("active").siblings().removeClass("active")
    })
// 点击报名--轮播图
new Swiper('#firstBanner', {
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 'auto',
    pagination: {
        el: '.benefit-s-pagination',
        clickable: true
    }
});


new Swiper('#secondBanner', {
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 'auto',
    pagination: {
        el: '.youhui-pagination',
        clickable: true
    }
});

new Bselector({
    showSelected: "#cityName",
    inputSelected: ".city03",
    options: [{ text: '北京市' }, { text: '天津市' }, { text: '上海市' }, { text: '重庆市' }, { text: '河北省' }, { text: '河南省' }, { text: '广东省' }, { text: '辽宁省' }, { text: '湖南省' }, { text: '四川省' }, { text: '安徽省' }, { text: '山东省' }, { text: '江苏省' }, { text: '浙江省' }, { text: '湖北省' }, { text: '山西省' }, { text: '陕西省' }, { text: '福建省' }, { text: '江西省' }, { text: '广西省' }, { text: '甘肃省' }, { text: '黑龙江省' }, { text: '内蒙古' }, { text: '吉林省' }, { text: '新疆维吾尔' }, { text: '贵州省' }, { text: '云南省' }, { text: '青海省' }, { text: '西藏' }, { text: '宁夏回族' }, { text: '海南省' }]
});


new Bselector({
    showSelected: "#cityName01",
    inputSelected: "#inputCity01",
    options: [{ text: '北京市' }, { text: '天津市' }, { text: '上海市' }, { text: '重庆市' }, { text: '河北省' }, { text: '河南省' }, { text: '广东省' }, { text: '辽宁省' }, { text: '湖南省' }, { text: '四川省' }, { text: '安徽省' }, { text: '山东省' }, { text: '江苏省' }, { text: '浙江省' }, { text: '湖北省' }, { text: '山西省' }, { text: '陕西省' }, { text: '福建省' }, { text: '江西省' }, { text: '广西省' }, { text: '甘肃省' }, { text: '黑龙江省' }, { text: '内蒙古' }, { text: '吉林省' }, { text: '新疆维吾尔' }, { text: '贵州省' }, { text: '云南省' }, { text: '青海省' }, { text: '西藏' }, { text: '宁夏回族' }, { text: '海南省' }]
});

// 点击报名
$(".benefit-second .list-btn").click(function(){
    $(".yuyue").show();
});
$(".yuyue-guanbi").click(function(){
    $(".yuyue").fadeOut();
})

$(".alert-icon").click(function(){
    $(".alert-bg").fadeOut();
})

$('.yuyue-form').listenForm({
    contentName: [{
      search: "",
      name: "web120盛典报名"
    }, {
      search: "?wb",
      name: "web120盛典报名(微博）"
    }, {
      search: "?tg",
      name: "web120盛典报名（推广）"
    }, {
      search: "?jtppzq",
      name: "web120盛典报名（百品）"
    }, {
        search: "?360jtppzq",
        name: "web120盛典报名（360）"
      }],
    submitTarget: '#yuyueBtn',
    cityRequired: true,
    successFun: function () {
      
      $(".alert-bg p").text("报名成功，专属顾问将尽快与您联系，请保持手机畅通！");
      $(".alert-bg").fadeIn();
      $(".yuyue").fadeOut();
    }

  });

// 立即领取
$('.city03').val($(".form-l-city").text());
  $('.benefit-s-form').listenForm({
    contentName: [{
      search: "",
      name: "web120领书"
    }, {
      search: "?wb",
      name: "web120领书(微博）"
    }, {
      search: "?tg",
      name: "web120领书（推广）"
    }, {
      search: "?jtppzq",
      name: "web120领书（百品）"
    }, {
        search: "?360jtppzq",
        name: "web120领书（360）"
      }],
    submitTarget: '.receive-btn',
    cityRequired: true,
    isMsg: true,
    smsInfo: '【新航道】120托福备考资料（电子版）下载地址：https://pan.baidu.com/s/14FDDZN284nxcWX2tNpnn4w ; 提取码：g98e',
    successFun: function () {
      
      $(".alert-bg p").text("申领成功，请注意查收手机短息，按提示操作领取");
      $(".alert-bg").fadeIn();
  
    }

  });


  // 报名享优惠
  $('.baoming').click(function () {
    var top1 = $('.youhui').offset().top;
    $('html,body').animate({
      scrollTop: top1
    });
  });
}